import { PersonalizationState } from './types/reducerTypes'
import { AnyAction } from 'redux'

const defaultState: PersonalizationState = {
  favorites: null,
  favoritesUrl: '',
  favoritesNextUrl: null,
  favoritesFullyLoaded: false,
  watchlist: null,
  watchlistUrl: '',
  watchlistNextUrl: null,
  watchlistFullyLoaded: false,
  watchHistory: null,
  watchHistoryUrl: '',
  watchHistoryNextUrl: null,
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'SET_FAVORITES':
      return {
        ...state,
        favorites: action.payload.content,
        favoritesUrl: action.payload.url,
        favoritesNextUrl: action.payload.nextUrl,
        favoritesFullyLoaded: action.payload.nextUrl === null,
      }
    case 'ADD_FAVORITE':
      return {
        ...state,
        favorites:
          state.favorites === null || state.favorites === 'error'
            ? [action.payload.favorite]
            : [action.payload.favorite, ...state.favorites],
      }
    case 'DELETE_FAVORITE':
      return {
        ...state,
        favorites: state.favorites.filter(
          (favorite: any) => favorite.cid !== action.payload.cid
        ),
      }
    case 'SET_WATCHLIST':
      return {
        ...state,
        watchlist: action.payload.content,
        watchlistUrl: action.payload.url,
        watchlistNextUrl: action.payload.nextUrl,
        watchlistFullyLoaded: action.payload.nextUrl === null,
      }
    case 'ADD_WATCHLIST':
      return {
        ...state,
        watchlist:
          state.watchlist === null || state.watchlist === 'error'
            ? [action.payload.watchlist]
            : [action.payload.watchlist, ...state.watchlist],
      }
    case 'DELETE_WATCHLIST':
      return {
        ...state,
        watchlist: state.watchlist.filter(
          (watchlist: any) => watchlist.cid !== action.payload.cid
        ),
      }
    case 'SET_WATCH_HISTORY':
      return {
        ...state,
        watchHistory: action.payload.content,
        watchHistoryUrl: action.payload.url,
        watchHistoryNextUrl: action.payload.nextUrl,
      }
    default:
      return state
  }
}
